<div class="d-flex gap-2" *ngIf="label">
  <label class="mb-2 global-form-field">{{ label }}</label>
  <span class="text-danger fw-bold" *ngIf="isRequired">*</span>
  <app-radio-group
    *ngIf="!isDisabled && !hideRadio"
    [name]="radioGroupName"
    [(ngModel)]="nrcGroup.NRCOldOrNew"
    (ngModelChange)="changeNrcType($event)"
    #paymeUserOldOrNewNRCInput="ngModel"
    [options]="oldNewOptions"
  />
</div>

<ng-container *ngIf="!skeletonLoading; else skeleton">
  <ng-container
    *ngTemplateOutlet="isDisabled ? disableBox : editableBox"
  ></ng-container>
</ng-container>

<ng-template #editableBox>
  @if(nrcGroup.NRCOldOrNew === 'NewNRC'){
  <div class="layout">
    <app-select
      style="flex: 1 0 70px; max-width: 85px"
      [id]="'NRCDivisionCode'"
      [name]="'NRCDivisionCode'"
      [(ngModel)]="nrcGroup.NRCDivisionCode"
      #NRCDivisionCodeENInput="ngModel"
      [options]="nrcDivisionList"
      (selectionChange)="getNrcData(nrcGroup.NRCDivisionCode, true)"
    />
    <app-select
      style="flex: 1 0 100px"
      [id]="'NRCTownShipCode'"
      [name]="'NRCTownShipCode'"
      [(ngModel)]="nrcGroup.NRCTownshipCode"
      #NRCTownShipCodeENInput="ngModel"
      [options]="nrcTownshipCodeList"
    />
    <app-select
      style="flex: 1 0 70px; max-width: 85px"
      [id]="'NRCNationality'"
      [name]="'NRCNationality'"
      [(ngModel)]="nrcGroup.NRCNationality"
      #NRCNationalityInput="ngModel"
      [options]="nrcNationalityCodeList"
    />
    <app-input
      style="flex: 1 0 100px"
      [id]="'NRCSerialNumber'"
      [name]="'NRCSerialNumber'"
      [maxlength]="6"
      [minlength]="6"
      [(ngModel)]="nrcGroup.NRCSerialNumber"
      [validateNumber]="true"
      #NRCSerialNumberInput="ngModel"
      (input)="nrcGroup.NRCSerialNumber = nrcGroup.NRCSerialNumber.substring(0, 6)"
      [inputMode]="NRCSerialNumberInput"
    />
  </div>
  }@else{
  <!-- Old NRC - Single Input Box -->
   <div>
      <app-input
        [id]="'oldNrc'"
        [name]="'oldNrc'"
        [(ngModel)]="oldNrc"
        (ngModelChange)="onOldNrcValueInput($event)"
        #oldNrcInput="ngModel"
        [inputMode]="oldNrcInput"
      />
    </div>
  <!-- <div *ngIf="oldNrc">
    <app-input
    [id]="'oldNrc'"
    [name]="'oldNrc'"
    [(ngModel)]="oldNrc"
    (ngModelChange)="onOldNrcValueInput($event)"
    #oldNrcInput="ngModel"
    [inputMode]="oldNrcInput"
  />
  </div>
  <div *ngIf="!oldNrc">
    <app-input
    [id]="'oldNrc'"
    [name]="'oldNrc'"
    [(ngModel)]="nrcGroup.NRCNumber" (ngModelChange)="onOldNrcValueInput($event)"
    #oldNrcInput="ngModel"
    [inputMode]="oldNrcInput"
  />
  </div> -->
  }
</ng-template>

<ng-template #disableBox>
  <app-input
    [id]="'oldNrc'"
    [name]="'oldNrc'"
    [(ngModel)]="nrcGroup.NRCNumber"
    [disabled]="true"
    #oldNrcInput="ngModel"
    [inputMode]="oldNrcInput"
  />
</ng-template>

<ng-template #skeleton>
  <ngx-skeleton-loader
    count="1"
    [theme]="{ 'border-radius': '5', height: '35px' }"
  />
</ng-template>
<!-- 

-->
